<template>
  <section class="com-b-wrap" style="border-radius: 10px">
    <div class="createCdkey">
      <div class="keyTitle"><i></i>生成兑换码</div>
      <div class="keyCont">
        <el-form ref="cdkey" :rules="cdkeyRules" :model="cdkeyForm" label-width="120px" size="small" style="width: 630px;">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="cdkeyForm.name" style="width: 515px"></el-input>
          </el-form-item>
          <el-form-item label="兑换码金额(元):" prop="money" style="margin-top: 30px">
            <el-input type="number" v-model="cdkeyForm.money" style="width: 245px"></el-input>
            <div class="cdKeyItem">
              <div>
                <img src="../../../static/img/money.png">
                <span>对应的积分为：</span>
              </div>
              <p>{{cdkeyForm.money*100}}</p>
              <span>分</span>
            </div>
          </el-form-item>
          <el-form-item label="兑换码数量(个):" prop="number" style="margin-top: 30px">
            <el-input v-model="cdkeyForm.number" type="number" style="width: 245px"></el-input>
            <div class="cdKeyItem">
              <div>
                <img src="../../../static/img/money.png">
                <span>消耗总积分为：</span>
              </div>
              <p>{{cdkeyForm.number*cdkeyForm.money*100}}</p>
              <span>分</span>
            </div>
          </el-form-item>

          <el-form-item label="到期时间:" prop="endTime">
            <el-date-picker
                v-model="cdkeyForm.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-top: 65px">
              <el-button size="small" @click="reset" style="border: 1px solid rgba(2, 47, 74, 0.26);;border-radius: 2px;color: #022F4A;width: 100px;">重设</el-button>
              <el-button size="small" @click="submit" style="border: 1px solid #00B1FF;border-radius: 2px;color: #ffffff;width: 100px;background: #00B1FF">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </section>
</template>

<script>
    import http from '@/http'
    export default {
        name: "CreateCdkey",
        data() {
            return {
                cdkeyForm: {
                  name: '',
                  money: '',
                  number: '',
                  endTime:''
                },
                cdkeyRules: {
                    name: [
                        { required: true, message: '请输入活动名称', trigger: 'blur' },
                    ],
                    money: [
                        { required: true, message: '请输入大于0的整数', trigger: 'change' }
                    ],
                    number: [
                        { required: true, message: '请输入大于0的整数', trigger: 'change' }
                    ],
                    endTime:[
                        { required: true, message: '请输入到期时间', trigger: 'change' }
                    ]
                },
                pickerOptions: {
          disabledDate(time) {
          return time.getTime() < Date.now()- 8.64e7;
          }
        }
            }
        },
        created() {
        },
        methods: {
            reset() {
                this.cdkeyForm = {
                    name: '',
                    money: '',
                    number: '',
                }
            },
            submit() {
                this.$refs.cdkey.validate((valid) => {
                    if (valid) {
                        var formData = new FormData
                        // formData.startTime = new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1).toString() + '-' + new Date().getDate().toString() + ' ' + new Date().getHours().toString() + ':' + (new Date().getMinutes()+1).toString() + ':' + new Date().getSeconds().toString()
                        formData.createUser = this.$store.getters.userId
                        formData.createUserName = this.$store.getters.userName
                        // formData.endTime = (new Date().getFullYear() + 50).toString() + '-' + (new Date().getMonth()+1).toString() + '-' + new Date().getDate().toString() + ' ' + '00:00:00'
                        formData.activityName = this.cdkeyForm.name
                        formData.point = this.cdkeyForm.money*100
                        formData.price = this.cdkeyForm.money * this.cdkeyForm.number
                        formData.nums = this.cdkeyForm.number
                        formData.endTime=this.cdkeyForm.endTime
                        http.postJson(this.globalConfig.domain.backstage + "/activity/recordActivity",formData ,(response) => {
                            if (response.data && response.data.success) {
                                this.$message.success(response.data.description || '生成成功')
                                this.reset()
                                setTimeout(() => {this.$router.push('/pages/ExchangeCode.html')},1000)

                            } else {
                                this.$message.error(response.data.description || '生成失败')
                            }
                        });
                    } else {
                        return false
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
  .createCdkey {
    width: 100%;
    background: #ffffff;
    margin: 20px auto 0;

    .keyTitle {
      width: 100%;
      padding: 15px 0 10px 0;
      font-size: 16px;
      font-weight: bold;
      color: #022F4A;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #EEEEEE;

      i {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #00B1FF;
        margin-right: 10px;
      }
    }

    .keyCont {
      padding: 70px 0 500px 80px;

      .cdKeyItem {
        width: 235px;
        height: 30px;
        padding: 0 10px;
        background: rgba(252,237,230,0.7);
        border-radius: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 25px;
        font-size: 18px;
        font-weight: bold;
        color: #F99900;

        div {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
        span {
          font-size: 14px;
          color: #022F4A;
          font-weight: 400;
        }
        p {
          max-width: 92px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
  /deep/ .el-button:hover {
    border: 1px solid #00B1FF !important;
    background: rgba(0, 177, 255, 0.11) !important;
    color: #00B1FF !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/CreateCdkey.vue